export var makeTitle = function makeTitle(props) {
  var theme = props.theme,
      as = props.as;
  return "font-size: ".concat(theme.fonts.sizes[as], ";\n          font-weight: 600;\n          margin: 0;");
};